/* REQUEST */
//import request from 'superagent/lib/client';
import Promise from 'es6-promise';

const getAppHeaders = () => {
    return { AppName: 'POS3'};
};

export default {

    encodeParams: (params ) => {
        var outparams   = [];
        var queryString = '?';
        for (var p in params){ outparams.push( p + '=' + params[p] ); }
        return  queryString += outparams.join('&');
    },

    GET:(url) => {
        var promise = new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                type:'GET',
                xhrFields: {
                    withCredentials: true,
                },
                headers: getAppHeaders(),
                success: function(data) {
                    resolve(data);
                },
                error:function(data) {
                    reject(data);
                },
            });
        });
        return promise;
    },
    POST:(url, formData) => {
        var promise = new Promise((resolve) => {
            $.ajax({
                url: url,
                type:'POST',
                xhrFields: {
                    withCredentials: true,
                },
                dataType: false,
                contentType: 'application/json; charset=utf-8',
                headers: getAppHeaders(),
                data: JSON.stringify(formData),
                start_time: new Date().getTime(),
                success: function(data) {
                    if (data.hasOwnProperty('Result')) {
                        if (data.Result === 'true')
                            data.Result = true;
                        else if (data.Result === 'false')
                            data.Result = false;
                    }

                    resolve(data);
                },
                error:function(data) {
                    if(!data.responseJSON) {
                        data.responseJSON = { Result: false };
                    } else if (!data.responseJSON.hasOwnProperty('Result')) {
                        data.responseJSON.Result = false;
                    }
                    resolve(data.responseJSON);
                },
            });
        });

        return promise;
    },
};



// WEBPACK FOOTER //
// ./ui_src/app/utils/AjaxPromises.js